import type { JSX } from 'react'

export const SoundOffIcon = (): JSX.Element => (
  <use href='#soundOffIcon' height='100%' width='100%' />
)
